import { Component, Input } from '@angular/core';
import { NonRepeatingEvent } from '../../../../../../../models/event-type';


@Component({
  selector: 'app-private-event-setup-nav',
  templateUrl: './private-event-setup-nav.component.html',
  styleUrls: ['./private-event-setup-nav.component.css']
})
export class PrivateEventSetupNavComponent {
  @Input() privateEvent: NonRepeatingEvent;
  @Input() loadingEvent: boolean;
}
